import { Pipe, PipeTransform } from '@angular/core';
import { Crop } from 'src/app/common/_models';
import { CropService } from '../../common/_services/crop.service';
@Pipe({
  name: 'datacrop',
  pure: true,
  standalone: false,
})
export class DatacropPipe implements PipeTransform {
  constructor(private cropService: CropService) {}

  transform(value: string | number): Crop | null {
    if (!value || value === undefined) {
      return null;
    }

    const selected = this.cropService.getCropById(Number(value));
    if (selected) {
      return selected;
    } else {
      return null;
    }
  }
}
